import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
interface Props {
  quantity: number;
  pricePerUnit: string;
  price: string;
  label?: string;
}
export default function QuantityOption(t0) {
  const $ = _c(24);
  const {
    quantity,
    pricePerUnit,
    price,
    label
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== quantity) {
    t1 = label ?? quantity.toLocaleString();
    $[0] = label;
    $[1] = quantity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedQuantity = t1;
  let t2;
  if ($[3] !== pricePerUnit) {
    t2 = CurrencyFormatter.formatUSD(Number(pricePerUnit));
    $[3] = pricePerUnit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formattedPerUnit = t2;
  let t3;
  if ($[5] !== price) {
    t3 = CurrencyFormatter.formatUSD(Number(price));
    $[5] = price;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const formattedPrice = t3;
  let t4;
  if ($[7] !== formattedPerUnit || $[8] !== formattedPrice || $[9] !== formattedQuantity) {
    t4 = <span className="sr-only">{formattedQuantity} quantity, {formattedPerUnit} each, total {formattedPrice}</span>;
    $[7] = formattedPerUnit;
    $[8] = formattedPrice;
    $[9] = formattedQuantity;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== formattedQuantity) {
    t5 = <span className="min-w-16 text-left font-medium">{formattedQuantity}</span>;
    $[11] = formattedQuantity;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== formattedPerUnit) {
    t6 = <span className="text-muted-foreground">{formattedPerUnit}/ea</span>;
    $[13] = formattedPerUnit;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== formattedPrice) {
    t7 = <span>{formattedPrice}</span>;
    $[15] = formattedPrice;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <span aria-hidden="true" className="flex w-full items-center justify-between gap-4 tabular-nums">{t5}{t6}{t7}</span>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t4 || $[22] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[21] = t4;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}